var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPwIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PW_Icon",
    "data-name": "PW Icon",
    transform: "translate(-704.875 -538.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-lock",
    "data-name": "Icon awesome-lock",
    d: "M25,14H23.5V9.5a9.5,9.5,0,0,0-19,0V14H3a3,3,0,0,0-3,3V29a3,3,0,0,0,3,3H25a3,3,0,0,0,3-3V17A3,3,0,0,0,25,14Zm-6.5,0h-9V9.5a4.5,4.5,0,0,1,9,0Z",
    transform: "translate(704.875 538.5)",
    fill: "#a2a2a2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwIcon);
export default __webpack_public_path__ + "static/media/PW Icon.f220c79ee5af01707401c9d45daa76bf.svg";
export { ForwardRef as ReactComponent };